import { useEffect } from "react";

export default function useSectionTracker(sectionNames) {
  useEffect(() => {
    const sections = sectionNames
      .map((name) => document.querySelector(`[data-section="${name}"]`))
      .filter(Boolean);

    if (!sections.length) return;

    const visible = new Map();

    const emitSection = (section) => {
      window.dispatchEvent(
        new CustomEvent("sectionchange", {
          detail: { section }
        })
      );
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const section = entry.target.dataset.section;

          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            visible.set(section, entry.intersectionRatio);
          } else {
            entry.target.classList.remove("is-visible");
            visible.delete(section);
          }
        });

        const topVisible = [...visible.entries()].sort((a, b) => b[1] - a[1])[0];
        if (topVisible) emitSection(topVisible[0]);
      },
      {
        // threshold: [0.05, 0.02, 0.45, 0.65],
        // rootMargin: "-10% 0px -30% 0px"
        threshold: [0.18, 0.35, 0.55, 0.75],
        rootMargin: "-8% 0px -18% 0px"
      }
    );

    sections.forEach((section) => observer.observe(section));

    const onTop = () => {
      if (window.scrollY < 80) {
        emitSection("home");
      }
    };

    window.addEventListener("scroll", onTop, { passive: true });
    onTop();

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", onTop);
    };
  }, [sectionNames]);
}